import React from 'react';
import { Link } from 'react-router-dom';
import './css/fitnesslogger.css';
import FLHeader from './FLHeader';


// TODO: CREATE HEADER COMPONENT 
export default function FitnessLogger() {
    return (
        <div className="fl">
           <FLHeader subtitle="Workout Logger &amp; Fitness Tracker App"/>

            <main className="fl__content">
                <p className="fl__intro">
                    FitnessLogger is a simple and powerful Workout Logger and Fitness Tracker
                    designed to help you record, organise, and review all of your training sessions
                    in one place. Whether you are lifting weights, improving your cardio, or tracking
                    sport-specific exercises, FitnessLogger makes it easy to log your workouts and
                    monitor your fitness progress tracker over time.
                </p>

                <hr className="fl__divider" />

                <nav className="fl__links" aria-label="Legal">
                    <Link to="/fitnesslogger/policy" className="fl__link">
                        Privacy Policy
                    </Link>
                    <Link to="/fitnesslogger/terms" className="fl__link">
                        Terms and Conditions
                    </Link>
                    <Link to="/fitnesslogger/delete" className="fl__link">
                        Delete Account
                    </Link>
                    
                
                    
                </nav>
            </main>
        </div>
    );
}
